{
    "order": {
        "show": {
            "greeting": {
                "introduction": "Bedankt dat u ervoor gekozen heeft om Sinterklaas Raalte te steunen met jouw bestelling!"
            },
            "customerCard": {
                "title": "Jouw gegevens",
                "delivery": "Wij komen langs op { date }, tussen { time } op {address}."
            },
            "stateAlert": {
                "refunded": "Je bestelling is terugbetaald. We komen niet meer langs. Is dit een foutje? Neem dan contact met ons op via (0572) 363603.",
                "deleted": "Je bestelling is geannuleerd. Is dit een foutje? Neem dan contact met ons op via (0572) 363603."
            }
        }
    },
    "checkout": {
        "service": {
            "label": "Kies het bezoektype dat u wilt"
        },
        "location": {
            "unsupportedLocation": "Op je adres kan niet online besteld worden. Je kunt altijd telefonisch contact opnemen via 0572-363603.",
            "allTimeslotsFull": "Er zijn online geen tijdvakken meer beschikbaar voor deze postcode. Je kunt altijd telefonisch contact opnemen via 0572-363603."
        },
        "product": {
            "noInventory": "Er zijn geen tijdvakken beschikbaar met genoeg voorraad voor je bestelling."
        },
        "customerRemark": {
            "label": "Opmerking",
            "placeholder": "Bijvoorbeeld: 'De kadootjes liggen in de garage.'"
        },
        "errors": {
            "noStock": "Er is niet genoeg voorraad om aan je bestelling te voldoen. Kies een ander bezoektype en probeer het opnieuw."
        }
    }
}
